import React from 'react'
import Csr from './csr'

const CsrIndex = () => {
    return (
        <Csr />
    )
}

export default CsrIndex